import { useRouteMatch, Route, Switch } from 'react-router-dom'

import BranchRentalPage from '@pages/Authorized/Branch/RentalPage'
import BranchRentalReservationPage from '@pages/Authorized/Branch/RentalReservationPage'

export default function BranchRentalRouter(): JSX.Element {
  const { url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${url}/list`}>
        <BranchRentalPage />
      </Route>
      <Route path={`${url}/reservation`}>
        <BranchRentalReservationPage />
      </Route>
    </Switch>
  )
}
